import { type Metric } from '../vessel_data'

export enum ChillerMetric {
  chiller1CoolingWater = 'chiller1CoolingWater',
  chiller2CoolingWater = 'chiller2CoolingWater',
  chiller3CoolingWater = 'chiller3CoolingWater',

  chiller1Compressor1 = 'chiller1Compressor1',
  chiller1Compressor2 = 'chiller1Compressor2',
  chiller1Compressor3 = 'chiller1Compressor3',

  chiller2Compressor1 = 'chiller2Compressor1',
  chiller2Compressor2 = 'chiller2Compressor2',
  chiller2Compressor3 = 'chiller2Compressor3',

  chiller3Compressor1 = 'chiller3Compressor1',
  chiller3Compressor2 = 'chiller3Compressor2',
  chiller3Compressor3 = 'chiller3Compressor3',
}

export type ChillerMetricName = keyof typeof ChillerMetric

export type ChillerMetrics = Record<ChillerMetricName, Metric>

export const allChillerMetricNames: ChillerMetricName[] = Object.values(ChillerMetric)
